import axios from 'axios';

export const generateAxiosInstanceCommon = () => {
  const baseURL = process.env.REACT_APP_BACKEND_COMMON_URL; // Your base URL
  const accessToken = localStorage.getItem('accessToken');
  return axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });
};